<div>
  <div class="vl-layout vl-layout--wide">
    <div class="vl-grid">
      <div class="vl-col--12-12 vl-col--12-12--m vl-col--12-12--s vl-col--1-1--xs vl-u-spacer">
        <h2 class="vl-title vl-title--h2">Geen toegang</h2>
      </div>
      <div class="vl-col--12-12 vl-col--12-12--m vl-col--12-12--s vl-col--1-1--xs">
        <!-- Begin content -->

        <div class="vl-alert vl-alert--error" role="alert">
          <div class="vl-alert__icon">
            <i class="vl-vi vl-vi-warning" aria-hidden="true"></i>
          </div>
          <div class="vl-alert__content">
            <div class="vl-alert__message">
              <p>
                U hebt geen toegangsrechten voor deze toepassing. Vraag de lokale beheerder van de organisatie waarvoor u deze toepassing
                wilt gebruiken om u de nodige toegangsrechten te geven.
              </p>
            </div>
          </div>
        </div>

        <!-- End content -->
      </div>
    </div>
  </div>
</div>
